"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowFieldsQueryGrid = exports.mapResultNode = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var FlowFieldsByIdQueryGql_1 = require("../../queries/FlowFieldsByIdQueryGql");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var FlowFieldsDisplayGrid_1 = require("./FlowFieldsDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.flows && resultData.flows[0] &&
        resultData.flows[0].outputSteps[0] && resultData.flows[0].outputSteps[0].outputFieldsConnection;
}
function mapResultNode(node, resultData) {
    if (node.__typename === 'FlowFieldOutputField') {
        var field = node && node.field;
        return {
            flowVizportalUrlId: resultData.flows[0].vizportalUrlId,
            id: node.id,
            name: node.name,
            fieldIcon: node && node.field && FieldFunctions_1.iconForField(node.field),
            sheetCount: field && field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null,
        };
    }
    else {
        var column = node && node.column;
        return {
            flowVizportalUrlId: resultData.flows[0].vizportalUrlId,
            id: node.id,
            name: node.name,
            fieldIcon: null,
            remoteType: column ? column.remoteType : undefined,
            sheetCount: column && column.downstreamSheetsConnection ? column.downstreamSheetsConnection.totalCount : null,
        };
    }
}
exports.mapResultNode = mapResultNode;
function FlowFieldsQueryGrid(props) {
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: FlowFieldsByIdQueryGql_1.FlowFieldsByIdQueryGql, partialQueryVariables: {
            flowVizportalUrlId: props.flowVizportalUrlId,
            selectedOutputStepId: props.selectedOutputStepId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(FlowFieldsDisplayGrid_1.FlowFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.FlowFieldsQueryGrid = FlowFieldsQueryGrid;
//# sourceMappingURL=FlowFieldsQueryGrid.js.map